/* React */
import React from 'react';

/* Styles */
import {
  Container,
  ContainerOut,
  Content,
  Titulo,
  Positions,
  Column,
  Square,
  SquareImg,
  Name,
  Points,
  Positions2,
  Positions3,
  Positions4,
  PositionsSec,
} from './styles';

import FormInput from '../../components/FormInput';
import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import coruja from '../../assets/img/coruja.png';

import { IUserData } from '../../interfaces/auth';

/* antd */
import {
  Form,
  Input,
  Row,
  Col,
  Descriptions,
  message,
  Button,
  Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

/* Intarfaces */
interface HomeProps {}
interface SignInCredentials {}

export const Ranking: React.FC<HomeProps> = () => {
  const props = {
    name: 'file',
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info: { file: { status: string; name: any }; fileList: any }) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  return (
    <>
      <Header />
      <Container>
        <ContainerOut>
          <Content>
            <Column>
              <Titulo>
                <h1>RANKING</h1>
              </Titulo>
              <Positions>
                <Square>
                  <h1>1</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Josue</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions>
              <Positions2>
                <Square>
                  <h1>2</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions2>
              <Positions3>
                <Square>
                  <h1>3</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions3>
              <Positions4>
                <Square>
                  <h1>4</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions4>
            </Column>
            <Column>
              <PositionsSec>
                <Square>
                  <h1>5</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Josue</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </PositionsSec>
              <Positions2>
                <Square>
                  <h1>6</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions2>
              <Positions3>
                <Square>
                  <h1>7</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions3>
              <Positions4>
                <Square>
                  <h1>8</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions4>
              <Positions4>
                <Square>
                  <h1>9</h1>
                </Square>
                <SquareImg>{/* <img src={coruja}></img> */}</SquareImg>
                <Name>
                  <h2>Maria</h2>
                  <Points>
                    <p>0 PTS</p>
                    <p>0 MIN</p>
                  </Points>
                </Name>
              </Positions4>
            </Column>
          </Content>
        </ContainerOut>
        <Footer />
      </Container>
    </>
  );
};
